import { render, staticRenderFns } from "./ReportCategories.vue?vue&type=template&id=5809a8ee&scoped=true&"
import script from "./ReportCategories.vue?vue&type=script&lang=js&"
export * from "./ReportCategories.vue?vue&type=script&lang=js&"
import style0 from "./ReportCategories.vue?vue&type=style&index=0&id=5809a8ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5809a8ee",
  null
  
)

export default component.exports